function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.2 11.2c-.77 0-1.393.63-1.393 1.4 0 .77.623 1.4 1.393 1.4s1.4-.63 1.4-1.4c0-.77-.63-1.4-1.4-1.4zM0 0v1.4h1.4l2.52 5.313-.945 1.715A1.353 1.353 0 002.8 9.1c0 .77.63 1.4 1.4 1.4h8.4V9.1H4.494a.173.173 0 01-.175-.175l.021-.084.63-1.141h5.215c.525 0 .987-.287 1.225-.721l2.506-4.543A.702.702 0 0013.3 1.4H2.947L2.289 0H0zm11.2 11.2c-.77 0-1.393.63-1.393 1.4 0 .77.623 1.4 1.393 1.4s1.4-.63 1.4-1.4c0-.77-.63-1.4-1.4-1.4z",
  fill: "#747474",
  fillRule: "evenodd"
});

function SvgOrder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    viewBox: "0 0 14 14"
  }, props), _ref);
}

export default SvgOrder;